import React, { FC } from 'react';
import Button from '../../atoms/buttons/Button';
import Container from '../blocks/Container';
import Headline from '../common/Headline';
import Panel from '../../atoms/panels/Panel';
import Text from '../common/Text';
import HeaderOut from '../../atoms/HeaderOut';
import { Link } from 'react-router-dom';
import NeedAccountMessage from '../../atoms/NeedAccountMessage';

const Unsubscribe: FC = () => {
  return (
    <Container width="thin">
      <HeaderOut marginBottom={10} />
      <Panel padding="large" style={{ background: '#FFF' }}>
        <Headline spaceAfter>We&apos;ve removed you from our database.</Headline>
        <Text>We apologize for the inconvenience.</Text>
        <div style={{ paddingTop: '100px' }}>
          {/* @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389 */}

          <Link
            onClick={() => {
              window.location.href = '/login';
            }}
          >
            <Button buttonType="primaryRed" customStyle={{ width: '100%' }}>
              Got it!
            </Button>
          </Link>
        </div>
      </Panel>
      <NeedAccountMessage />
    </Container>
  );
};

export default Unsubscribe;
